import { readyFarge } from "./eventosUtils";

export const ReadinessBadge = ({ computed, size = "sm" }) => {
  if (!computed) return null;
  const farge = readyFarge(computed.completeness, computed.blockers);
  return (
    <span className={`inline-flex items-center gap-1.5 ${size === "sm" ? "text-[11px]" : "text-[12.5px]"}`}>
      <span className="relative inline-flex w-[26px] h-[5px] rounded-full bg-neutral-200 overflow-hidden">
        <span className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${computed.completeness}%`, background: farge }} />
      </span>
      <span className="tabular-nums font-medium" style={{ color: farge }}>{computed.completeness}%</span>
      {computed.blockers > 0 && (
        <span className="text-[10px] font-bold text-red-600 bg-red-50 rounded px-1 py-px">
          {computed.blockers} blocker{computed.blockers > 1 ? "e" : ""}
        </span>
      )}
    </span>
  );
};

const NESTE = { open: "done", done: "na", na: "open" };

export const ReadinessListe = ({ computed, onSett, testidPrefix }) => (
  <div className="space-y-0.5" data-testid={`${testidPrefix}-readiness`}>
    {(computed?.items || []).map((it) => {
      const kanEndres = !it.auto;
      return (
        <button
          key={it.key}
          type="button"
          disabled={!kanEndres}
          onClick={() => kanEndres && onSett({ [it.key]: NESTE[it.state] })}
          className={`w-full flex items-center gap-2.5 py-1.5 px-2 -mx-2 rounded-lg text-left transition-colors ${kanEndres ? "hover:bg-neutral-50 cursor-pointer" : "cursor-default"}`}
          data-testid={`${testidPrefix}-readiness-${it.key}`}
          title={it.auto ? "Beregnes automatisk" : "Klikk: åpen → utført → N/A"}
        >
          <span
            className={`w-[15px] h-[15px] rounded-full border flex items-center justify-center shrink-0 text-[9px] font-bold ${
              it.state === "done"
                ? "bg-emerald-500 border-emerald-500 text-white"
                : it.state === "na"
                ? "bg-neutral-100 border-neutral-200 text-neutral-400"
                : it.blocker
                ? "border-red-400 text-red-500"
                : "border-neutral-300 text-transparent"
            }`}
          >
            {it.state === "done" ? "✓" : it.state === "na" ? "–" : it.blocker ? "!" : ""}
          </span>
          <span className={`flex-1 text-[12.5px] ${it.state === "na" ? "text-neutral-300 line-through" : it.state === "done" ? "text-neutral-500" : "text-neutral-800"}`}>
            {it.label}
          </span>
          {it.auto && <span className="text-[9px] uppercase tracking-wider text-neutral-300">auto</span>}
          {it.blocker && it.state === "open" && (
            <span className="text-[9px] font-bold uppercase tracking-wider text-red-500">blocker</span>
          )}
        </button>
      );
    })}
  </div>
);
